export const addSecondsToDate = (date: Date | string, seconds: number) => {
  const d = new Date(date);
  d.setSeconds(d.getSeconds() + seconds);
  return d;
};
